import { render, staticRenderFns } from "./editSysmenu.vue?vue&type=template&id=ff6fa82a&"
import script from "./editSysmenu.vue?vue&type=script&lang=js&"
export * from "./editSysmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports